import { observer } from "mobx-react";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useStores } from "../../stores/root-store";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VoucherListing from "./voucher-listing";
import VoucherForm from "./voucher-form";

const ManageVouchers = observer(() => {
  const { voucherStore } = useStores();
  const { editVoucher, setEditVoucher } = voucherStore;
  const [showVoucherForm, setShowVoucherForm] = useState(false);

  const handleVoucherFormClose = (show: boolean) => {
    setShowVoucherForm(show);
    if (!show) setEditVoucher(null, false);
  };

  useEffect(() => {
    setShowVoucherForm(editVoucher != null);
  }, [editVoucher]);

  return (
    <div className="container mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 text-start">
          Vouchers
          <Button
            onClick={() => setShowVoucherForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            New Voucher
          </Button>
        </h5>
      </div>
      <VoucherListing />
      {showVoucherForm && (
        <VoucherForm
          show={showVoucherForm}
          setShowModal={handleVoucherFormClose}
        />
      )}
    </div>
  );
});

export default ManageVouchers;
